
import { createSlice } from '@reduxjs/toolkit'
const initialState = {
webshopSettings:{},
webshopLoading:false,
 webShopCategoryList:[],
 webShopProductList:[],
 webShopProductInfo:[],
 languageData:[],
 defaultLanguage:'',
 deliveryType:'',
 shopType:'',
 widgetUrl:'',
 webShopMenuPosition:'',
 selectedMenuItem:'',
 isProductLoading:false,
 itemCount:{},
 totalProductsCount:0,
 supplementsInfo:[],
 selectedProduct:{},
 selectedRecommendedProduct:{},
 addToCartProducts:[],
 selectedDeleteItem:{},
 selectedProductTotalPrice:0,
 guestDetails:null,
 orderNumberDetails:{},
 openCart : false,
 viewCartCount:0,
 addToCartOpen:false,
 paymentMethodOpen:false,
 checkoutDetails:null,
 totalPrices:0,
 webshopOpeningHours:{},
 webshopTimeSlots:[],
 webshopFileds:[],
 guestData:[],
 additionalFields:[],
 reletedProductsInfo:[],
 singleProductTotalIncludeSupp:{},
 languageWords:{},
 recommendedProductError:'',
 supplementError:{},
}
export const WebshopSlice = createSlice({
  name: 'Webshop',
  initialState,
  reducers: {
    setWebshopCategoryData: (state, action) => {
      state.webShopCategoryList = action.payload;
    },
    setLanguageData: (state, action) => {
      state.languageData = action.payload;
    },
    updateDefaultLanguage: (state, action) => {
        state.defaultLanguage = action.payload;
    },
    updateDeliveryType: (state, action) => {
        state.deliveryType = action.payload;
      },
      updateShopType: (state, action) => {
        state.shopType = action.payload
      },
      updateWidgetUrl: (state, action) => {
        state.widgetUrl = action.payload;
      },
      updateWebShopMenuPosition: (state, action) => {
        state.webShopMenuPosition = action.payload;
      },
      updateSelectedMenuItem: (state, action) => {
        state.selectedMenuItem = action.payload;
      },
      setWebshopProductData: (state, action) => {
        state.webShopProductList = action.payload;
      },
      setIsProductLoading: (state, action) => {
        state.isProductLoading = action.payload;
      },
      setWebshopProductInfo: (state, action) => {
        state.webShopProductInfo = action.payload;
      },
      setWebshopRelatedProductsInfo: (state, action) => {
        state.reletedProductsInfo = action.payload;
      },
      setItemCount: (state, action) => {
        state.itemCount =  action.payload;  
      },
      setSupplementInfo: (state, action) => {
        state.supplementsInfo =action.payload;
      },
      setSelectedProduct: (state, action) => {
        state.selectedProduct =action?.payload;
      },
      setWebshopSettings: (state, action) => {
        state.webshopSettings = action.payload;
      },
      setWebshopLoading: (state, action) => {
        state.webshopLoading = action.payload;
      },
      setTotalProductCount: (state, action) => {
        state.totalProductsCount = action.payload;
      },
      UpdateAddToCartProducts: (state, action) => {
        state.addToCartProducts = [...state.addToCartProducts, action.payload];
      },
      deleteAddToCartProducts: (state, action) => {
        console.log("action",action.payload);
        state.addToCartProducts = state.addToCartProducts.filter((product) => product.idproduct!== action.payload);
 // Correctly update itemCount by setting the specific item count to 1
 state.itemCount = {
  ...state.itemCount,
  [action.payload]: 1 // Use correct object property assignment
};
      },
      removeAddToCartProducts:(state, action) => {
        state.addToCartProducts = []

      },
       // Add more reducer functions as needed...
       setSelectedDeleteItem:(state, action) => {
        state.selectedDeleteItem = action.payload;
       },
       updateSelectedProductTotalPrice:(state, action) => {
        state.selectedProductTotalPrice = action.payload;
       },
       updateGuestDetails:(state, action) => {
        state.guestDetails = action.payload;
       },
       updateOrderNumberDetails:(state, action) => {
        state.orderNumberDetails = action.payload;

       },
       setOpenCart:(state, action) => {
        state.openCart = action.payload;
       },
       setViewCartCount:(state, action) => {
        state.viewCartCount = action.payload;
       },
       resetKiosk:(state)=>{
        // state.selectedMenuItem =initialState.selectedMenuItem
        state.addToCartProducts = initialState.addToCartProducts
        state.selectedProduct = initialState.selectedProduct
        state.itemCount=initialState.itemCount
        state.totalProductsCount = initialState.totalProductsCount 
        state.addToCartOpen=initialState.addToCartOpen
        state.paymentMethodOpen=initialState.paymentMethodOpen
        state.openCart=initialState.openCart
       state.webShopCategoryList=initialState.webShopCategoryList
       state.webShopProductList=initialState.webShopProductList
       state.webShopProductInfo=initialState.webShopProductInfo
       state.languageData=initialState.languageData
       state.defaultLanguage=initialState.defaultLanguage
       state.deliveryType=initialState.deliveryType

       },
       setAddToCartOpen:(state, action) => {
        state.addToCartOpen = action.payload;
       },
       setPaymentMethodOpen:(state, action) => {
        state.paymentMethodOpen = action.payload;
       },
       updateCheckoutDetails:(state, action) => {
        state.checkoutDetails = action.payload;
       },
       updateTotalPrice:(state, action) => {
        state.totalPrices = action.payload;
       },
       updateWebshopOpeningHours:(state, action) => {
        state.webshopOpeningHours = action.payload;
       },
       updateWebshopTimeSlots:(state, action) => {
        state.webshopTimeSlots = action.payload;
       },
       setWebshopFileds:(state, action) => {
        state.webshopFileds = action.payload;
       },
       setGuestData:(state, action) => {
        state.guestData = action.payload;
       },
       setAdditionalFields:(state, action) => {
        state.additionalFields = action.payload;
       },
       setSingleProductTotalIncludeSupp:(state, action) => {
        state.singleProductTotalIncludeSupp = action.payload;
       },
       setLanguageWords:(state, action) => {
        state.languageWords = action.payload;
       },
       setRecommendedProductError:(state, action) => {
        state.recommendedProductError = action.payload;
       },
       setSupplementError:(state, action) => {
        state.supplementError = action.payload;
       },
       setSelectedRecommendedProduct:(state, action) => {
        state.selectedRecommendedProduct = action.payload;
       }

       // Add more action creators as needed...
      
  },
})

// Action creators are generated for each case reducer function
export const {
setWebshopCategoryData,
  setLanguageData,
  updateDefaultLanguage,
  updateDeliveryType,
  updateShopType,
  updateWidgetUrl,
  updateWebShopMenuPosition,
  updateSelectedMenuItem,
  setWebshopProductData,
  setIsProductLoading,
  setWebshopProductInfo,
  setItemCount,
  setSupplementInfo,
  setSelectedProduct,
  setWebshopSettings,
  setWebshopLoading,
  setTotalProductCount,
  UpdateAddToCartProducts,
  removeAddToCartProducts,
  deleteAddToCartProducts,
  setSelectedDeleteItem,
  updateSelectedProductTotalPrice,
  updateGuestDetails,
  updateOrderNumberDetails,
  setOpenCart,
  setViewCartCount,
  setAddToCartOpen,
  resetKiosk,
  setPaymentMethodOpen,
  updateCheckoutDetails,
  updateTotalPrice,
  updateWebshopOpeningHours,
  updateWebshopTimeSlots,
  setWebshopFileds,
  setGuestData,
  setAdditionalFields,
  setWebshopRelatedProductsInfo,
  setSingleProductTotalIncludeSupp,
  setLanguageWords,
  setRecommendedProductError,
  setSupplementError,
  setSelectedRecommendedProduct
  // Add more action creators as needed...
} = WebshopSlice.actions

export default WebshopSlice.reducer;
